/* Zdruzevanje izdelkov po druzinah (isti "Art." + razlicne mere) NA STRANI KOLEKCIJE — client-side.
   Strezniska stran ostane navadna in hitra; ta skript po nalaganju povlece VSE izdelke kolekcije iz
   products.json (tudi >250, prek strani), jih zdruzi, razvrsti po Art. kodi in prikaze po 50 druzin.
   Vzor: enak pristop kot izbirnik mer na strani izdelka (product-info.liquid). */
(function () {
  'use strict';
  // The asset can be encountered again when another collection section is loaded.
  // Keep one manager; each connected grid owns its own cancellable request chain.
  if (window.PoletCollectionFamilies) {
    window.PoletCollectionFamilies.mount();
    return;
  }
  var active = null;
  function pageKey() { return location.pathname + location.search; }
  function stop() {
    if (active) active.dispose();
    active = null;
  }
  function mount() {
    var grid = document.querySelector('#infinitypagination[data-druzine-vir]');
    var key = pageKey();
    if (active && active.grid === grid && active.key === key) return;
    stop();
    // Filters and explicit sorting must retain the server's current result set.
    if (!grid || /[?&](filter\.|sort_by=)/.test(location.search)) return;
    var handle = grid.getAttribute('data-druzine-vir');
    if (!handle) return;
    active = createGrouping(grid, handle, key);
    active.start();
  }
  window.PoletCollectionFamilies = { mount: mount };
  document.addEventListener('collection:navigation:before', stop);
  document.addEventListener('collection:navigation:complete', mount);
  document.addEventListener('shopify:section:load', mount);
  document.addEventListener('shopify:section:unload', function (event) {
    if (active && event.target.contains(active.grid)) stop();
  });
  document.addEventListener('theme:loading:start', function () {
    // Native filters update the URL before starting their fetch. Never let an
    // older family request overwrite the newly requested filtered results.
    if (active && active.key !== pageKey()) stop();
  });
  document.addEventListener('theme:loading:end', mount);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount, { once: true });
  else mount();

  function createGrouping(grid, handle, key) {
  var controller = new AbortController();
  var disposed = false;
  var loading = false;
  var restore = function () {};
  var session = { grid: grid, key: key, start: zacni, dispose: function () {
    disposed = true;
    controller.abort();
    if (loading && grid.isConnected) restore();
    grid.removeAttribute('aria-busy');
  } };
  function isCurrent() { return !disposed && grid.isConnected && session.key === pageKey(); }
  function requireCurrent() {
    if (!isCurrent()) {
      var error = new Error('Collection changed.');
      error.name = 'AbortError';
      throw error;
    }
  }
  var PAGE_SIZE = 50;
  var CACHE_KEY = 'druzine-kol-' + handle + '-v2';
  var TTL = 10 * 60 * 1000; // 10 min

  function denar(n) {
    return n.toFixed(2).replace('.', ',') + ' €';
  }
  function minCena(p) {
    var m = Infinity;
    (p.variants || []).forEach(function (v) { var c = parseFloat(v.price); if (!isNaN(c) && c < m) m = c; });
    return m === Infinity ? null : m;
  }
  function compareMax(p) {
    var m = 0;
    (p.variants || []).forEach(function (v) { var c = parseFloat(v.compare_at_price); if (!isNaN(c) && c > m) m = c; });
    return m;
  }
  function prvaVariantaNaVoljo(p) {
    var v = (p.variants || []).find(function (x) { return x.available; }) || (p.variants || [])[0];
    return v ? v.id : null;
  }
  function naVoljo(p) {
    return (p.variants || []).some(function (v) { return v.available; });
  }
  function slika(p) {
    if (p.images && p.images[0]) return p.images[0].src;
    var v = (p.variants || []).find(function (x) { return x.featured_image; });
    return v && v.featured_image ? v.featured_image.src : '';
  }
  function slikaSirina(src, w) {
    if (!src) return '';
    return src.indexOf('?') > -1 ? src + '&width=' + w : src + '?width=' + w;
  }
  function kljuc(title) {
    // Druzina = isto ime + isti "Art.KODA", ce kodi sledi mera (mm, TX, cm, g, kg, M, E, col ...).
    // Izjema: momentni kljuci (Nm) ostanejo posamezni.
    if (title.indexOf('Art.') > -1 && !/\d ?Nm\b/.test(title)) {
      var pred = title.split('Art.')[0].trim().toLowerCase();
      var po = title.split('Art.')[1].trim();
      var koda = po.split(' ')[0].replace(/[,.]+$/, '').toLowerCase();
      var mera = po.split(' ').slice(1).join(' ').replace(/\(\d+\)\s*$/, '').trim();
      if (mera) return pred + ' art.' + koda;
    }
    return '__' + title.toLowerCase(); // unikaten -> posamezna kartica
  }
  function imeDruzine(title) {
    var base = title.split(' mm')[0];
    if (title.indexOf('Art.') > -1) {
      var pred = title.split('Art.')[0].trim();
      var koda = title.split('Art.')[1].trim().split(' ')[0].replace(/[,.]+$/, '');
      base = pred + ' Art.' + koda;
    }
    return base;
  }
  function jeSet(p) {
    return /kos|garnitur|kartonu/i.test(p.title);
  }
  function jeNaZalogi(p) {
    return (p.tags || []).some(function (t) { return /na zalogi/i.test(t); });
  }

  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function znacka(cena, comp) {
    if (comp && comp > cena) {
      var pct = Math.round((comp - cena) / comp * 100);
      if (pct >= 1) return '<div class="product-item__label-list"><span class="product-label product-label--custom">- ' + pct + '%</span></div>';
    }
    return '';
  }

  function slikaHtml(src, alt) {
    if (!src) return '';
    var s2 = esc(src);
    return '<div class="aspect-ratio aspect-ratio--square" style="padding-bottom:100%">' +
      '<img class="product-item__primary-image" loading="lazy" decoding="async" alt="' + esc(alt) + '" ' +
      'src="' + slikaSirina(s2, 400) + '" ' +
      'srcset="' + slikaSirina(s2, 300) + ' 300w, ' + slikaSirina(s2, 400) + ' 400w, ' + slikaSirina(s2, 600) + ' 600w" ' +
      'sizes="(max-width: 499px) 45vw, (max-width: 999px) 30vw, 280px"></div>';
  }

  function karticaDruzine(rep, cena, gridClasses) {
    var url = '/products/' + rep.handle;
    return '<div class="product-item product-item--vertical ' + gridClasses + '">' +
      '<a href="' + url + '" class="product-item__image-wrapper">' + slikaHtml(slika(rep), imeDruzine(rep.title)) + '</a>' +
      '<div class="product-item__info"><div class="product-item__info-inner">' +
      '<a href="' + url + '" class="product-item__title text--strong link">' + esc(imeDruzine(rep.title)) + '</a>' +
      '<div class="product-item__price-list price-list"><span class="price price--highlight">od ' + denar(cena) + '</span></div>' +
      '</div>' +
      '<div class="product-item__action-list button-stack">' +
      '<a href="' + url + '" class="product-item__action-button button button--small button--primary">Izberi mero</a>' +
      '</div></div></div>';
  }

  function isStoreOnlyProduct(product) {
    var tags = product.tags || [];
    if (typeof tags === 'string') tags = tags.split(',');
    return tags.some(function (tag) { return String(tag).trim().toLowerCase() === 'samo v trgovini'; });
  }

  function karticaPosamezna(p, gridClasses) {
    var url = '/products/' + p.handle;
    var cena = minCena(p);
    var comp = compareMax(p);
    var vid = prvaVariantaNaVoljo(p);
    var cenaHtml = '<span class="price price--highlight">' + denar(cena) + '</span>';
    if (comp && comp > cena) cenaHtml += ' <span class="price price--compare">' + denar(comp) + '</span>';
    var na = naVoljo(p);
    var zaloga = jeNaZalogi(p)
      ? '<span class="product-item__inventory inventory inventory--high">Na zalogi</span>'
      : (na ? '<span class="product-item__inventory inventory inventory--high">Na voljo v 2-4 dneh</span>'
                     : '<span class="product-item__inventory inventory inventory--low">Po naročilu</span>');
    var gumb;
    if (isStoreOnlyProduct(p)) {
      zaloga = '<span class="product-item__inventory inventory">Prevzem samo v trgovini</span>';
      gumb = '<div class="product-item__action-list button-stack"><a href="tel:017878271" class="product-item__action-button button button--small button--secondary">Pokličite za zalogo</a></div>';
    } else if (na && vid) {
      gumb = '<form action="/cart/add" method="post" class="product-item__action-list button-stack" enctype="multipart/form-data">' +
        '<input type="hidden" name="quantity" value="1"><input type="hidden" name="id" value="' + vid + '">' +
        '<button type="submit" class="product-item__action-button button button--small button--primary" data-action="add-to-cart">V košarico</button></form>';
    } else {
      gumb = '<div class="product-item__action-list button-stack"><a href="' + url + '" class="product-item__action-button button button--small button--primary">Poglej</a></div>';
    }
    return '<div class="product-item product-item--vertical ' + gridClasses + '">' +
      znacka(cena, comp) +
      '<a href="' + url + '" class="product-item__image-wrapper">' + slikaHtml(slika(p), p.title) + '</a>' +
      '<div class="product-item__info"><div class="product-item__info-inner">' +
      '<a href="' + url + '" class="product-item__title text--strong link">' + esc(p.title) + '</a>' +
      zaloga +
      '<div class="product-item__price-list price-list">' + cenaHtml + '</div>' +
      '</div>' + gumb + '</div></div>';
  }

  function vstaviStil() {
    if (document.getElementById('druzine-skelet-stil')) return;
    var st = document.createElement('style'); st.id = 'druzine-skelet-stil';
    st.textContent = '@keyframes druzineUtrip{0%{opacity:.55}50%{opacity:1}100%{opacity:.55}}' +
      '.product-item.druzine-skelet{pointer-events:none;padding:14px 12px;box-sizing:border-box}' +
      '.druzine-skelet .dz-sk{background:#eceef1;border-radius:8px;animation:druzineUtrip 1.1s ease-in-out infinite}' +
      '.druzine-skelet .dz-sk-slika{width:100%;padding-bottom:100%;border-radius:10px;margin-bottom:12px}' +
      '.druzine-skelet .dz-sk-vr{height:12px;margin:8px 0}' +
      '.druzine-skelet .dz-sk-cena{height:18px;width:45%;margin:12px 0 14px}' +
      '.druzine-skelet .dz-sk-gumb{height:34px;width:70%;border-radius:999px}';
    document.head.appendChild(st);
  }
  function skeletonHtml(n, gc) {
    var one = '<div class="product-item product-item--vertical ' + gc + ' druzine-skelet">' +
      '<div class="dz-sk dz-sk-slika"></div>' +
      '<div class="dz-sk dz-sk-vr" style="width:85%"></div>' +
      '<div class="dz-sk dz-sk-vr" style="width:55%"></div>' +
      '<div class="dz-sk dz-sk-cena"></div>' +
      '<div class="dz-sk dz-sk-gumb"></div></div>';
    var out = '';
    for (var i = 0; i < n; i++) out += one;
    return out;
  }

  function pridobiVse() {
    // cache
    try {
      var raw = sessionStorage.getItem(CACHE_KEY);
      if (raw) { var w = JSON.parse(raw); if (w && (Date.now() - w.t) < TTL && Array.isArray(w.p)) return Promise.resolve(w.p); }
    } catch (e) {}
    var vsi = [];
    function stran(n) {
      requireCurrent();
      return fetch('/collections/' + handle + '/products.json?limit=250&page=' + n, { credentials: 'same-origin', signal: controller.signal })
        .then(function (r) {
          requireCurrent();
          if (!r.ok) throw new Error('Izdelkov ni bilo mogoce naloziti.');
          return r.json();
        })
        .then(function (d) {
          requireCurrent();
          if (!d || !Array.isArray(d.products)) throw new Error('Neveljaven seznam izdelkov.');
          var arr = d.products;
          vsi = vsi.concat(arr);
          if (arr.length === 250) return stran(n + 1);
        });
    }
    return stran(1).then(function () {
      requireCurrent();
      try { sessionStorage.setItem(CACHE_KEY, JSON.stringify({ t: Date.now(), p: vsi })); } catch (e) {}
      return vsi;
    });
  }

  function gridClassesIz() {
    var prvi = grid.querySelector('.product-item');
    if (!prvi) return '1/2--phone 1/3--tablet 1/4--lap-and-up';
    // poberi mrezne razrede z obstojece kartice (npr. "1/3--tablet 1/4--desk ...")
    return Array.prototype.filter.call(prvi.classList, function (c) { return c.indexOf('/') > -1; }).join(' ');
  }

  function urlStrani(n) {
    var url = new URL(location.href);
    if (n === 1) url.searchParams.delete('page');
    else url.searchParams.set('page', n);
    url.hash = '';
    return url.pathname + url.search;
  }

  function navigacija(stran, strani, stevec) {
    var out = '<p class="text--small" data-druzine-count>' + esc(stevec) + '</p>';
    if (strani === 1) return out;
    out += '<nav class="pagination" aria-label="Strani skupin izdelkov"><div class="pagination__inner"><div class="pagination__nav">';
    // Brez data-page: povezave odprejo pravo stran, temin AJAX za surove izdelke jih ne prestreze.
    if (stran > 1) out += '<a class="pagination__prev link" style="order:0" rel="prev" href="' + esc(urlStrani(stran - 1)) + '">Prejšnja</a>';
    if (stran < strani) out += '<a class="pagination__next link" style="order:2" rel="next" href="' + esc(urlStrani(stran + 1)) + '">Naslednja</a>';
    out += '<div style="order:1">';
    var zadnja = 0;
    for (var n = 1; n <= strani; n++) {
      if (n !== 1 && n !== strani && Math.abs(n - stran) > 1) continue;
      if (n - zadnja > 1) out += '<span class="pagination__nav-item" aria-hidden="true">…</span>';
      if (n === stran) out += '<span class="pagination__nav-item is-active" aria-current="page">' + n + '</span>';
      else out += '<a class="pagination__nav-item link" href="' + esc(urlStrani(n)) + '" aria-label="Pojdi na stran ' + n + '">' + n + '</a>';
      zadnja = n;
    }
    return out + '</div></div><span class="pagination__page-count">Stran ' + stran + ' od ' + strani + '</span></div></nav>';
  }

  function zgradi(izdelki, gc) {
    requireCurrent();
    if (!izdelki || !izdelki.length) { return; }
    // zdruzi po kljucu
    var mapa = Object.create(null);
    izdelki.forEach(function (p) {
      var k = kljuc(p.title);
      (mapa[k] || (mapa[k] = [])).push(p);
    });
    var kartice = [];
    Object.keys(mapa).forEach(function (k) {
      var clani = mapa[k];
      // najcenejsi clan = predstavnik
      var rep = clani[0], repC = minCena(clani[0]) || Infinity;
      clani.forEach(function (p) { var c = minCena(p); if (c != null && c < repC) { repC = c; rep = p; } });
      var html, cena = repC === Infinity ? 0 : repC;
      if (clani.length > 1) html = karticaDruzine(rep, cena, gc);
      else html = karticaPosamezna(rep, gc);
      // razvrscanje po Art. kodi (110, 114, 193TX ...), kot v Unior katalogu
      var koda = '';
      if (rep.title.indexOf('Art.') > -1) koda = rep.title.split('Art.')[1].trim().split(' ')[0].replace(/[,.]+$/, '');
      var st = koda.match(/^\d+/);
      kartice.push({ n: st ? parseInt(st[0], 10) : Infinity, koda: koda.toLowerCase(), t: rep.title.toLowerCase(), h: html });
    });
    kartice.sort(function (a, b) {
      if (a.n !== b.n) return a.n - b.n;
      if (a.koda !== b.koda) return a.koda.localeCompare(b.koda, undefined, { numeric: true });
      return a.t.localeCompare(b.t);
    });
    var strani = Math.ceil(kartice.length / PAGE_SIZE);
    var zahtevana = new URL(location.href).searchParams.get('page');
    var stran = Math.min(strani, /^[1-9]\d*$/.test(zahtevana || '') ? Number(zahtevana) : 1);
    var zacetek = (stran - 1) * PAGE_SIZE;
    var konec = Math.min(zacetek + PAGE_SIZE, kartice.length);
    var stevec = 'Prikaz: ' + (zacetek + 1) + '–' + konec + ' od ' + kartice.length + ' skupin izdelkov';
    var html = kartice.slice(zacetek, konec).map(function (x) { return x.h; }).join('');
    grid.innerHTML = html;
    // Strezniska paginacija steje posamezne izdelke; tukaj stevilo strani temelji na celih druzinah.
    var pag = grid.parentNode.querySelector('.pagination');
    if (pag) pag.style.display = 'none';
    var kontrolniki = document.createElement('div');
    kontrolniki.setAttribute('data-druzine-pagination', '');
    kontrolniki.innerHTML = navigacija(stran, strani, stevec);
    grid.insertAdjacentElement('afterend', kontrolniki);
    var sekcija = grid.closest('[data-section-type="collection"]');
    if (sekcija) {
      sekcija.querySelectorAll('.collection__products-count-showing, .collection__showing-count').forEach(function (el) { el.textContent = stevec; });
      sekcija.querySelectorAll('.collection__products-count-total').forEach(function (el) { el.textContent = 'Skupine izdelkov: ' + kartice.length; });
    }
    if (zahtevana && zahtevana !== String(stran)) {
      history.replaceState(history.state, '', urlStrani(stran));
      session.key = pageKey();
    }
    // Collection controls use delegated listeners. A second section:load here
    // would instantiate another controller and duplicate cart/filter requests.
  }

  function zacni() {
    if (!isCurrent()) return;
    loading = true;
    var gc = gridClassesIz();
    var original = grid.innerHTML;
    var n = grid.querySelectorAll('.product-item').length || 8;
    vstaviStil();
    grid.innerHTML = skeletonHtml(n, gc);
    grid.setAttribute('aria-busy', 'true');
    var pag = grid.parentNode.querySelector('.pagination');
    var vidnost = pag ? pag.style.visibility : '';
    var prikaz = pag ? pag.style.display : '';
    if (pag) pag.style.visibility = 'hidden';
    function obnovi() {
      grid.innerHTML = original;
      var kontrolniki = grid.parentNode.querySelector('[data-druzine-pagination]');
      if (kontrolniki) kontrolniki.remove();
      if (pag) { pag.style.visibility = vidnost; pag.style.display = prikaz; }
    }
    restore = obnovi;
    pridobiVse().then(function (izdelki) {
      requireCurrent();
      if (izdelki && izdelki.length) zgradi(izdelki, gc);
      else obnovi();
    }).catch(function () {
      if (isCurrent()) obnovi();
    }).then(function () {
      loading = false;
      if (isCurrent()) grid.removeAttribute('aria-busy');
    });
  }
  return session;
  }
})();
